/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { Subject, combineLatest } from 'rxjs';
import { filter, switchMap, withLatestFrom } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Permission } from '../models/permissions.interface';
import { FeatureFlagService } from './feature-flag/feature-flag.service';
import { PermissionService } from './permissions/permission.service';
import { UserService } from './user/user.service';

// eslint-disable-next-line no-var
declare var pendo: any;

@Injectable({
  providedIn: 'root',
})
export class PendoService {
  private _identify$ = new Subject<void>();
  private _isInitialized = false;

  constructor(
    private _featureFlagService: FeatureFlagService,
    private _permissionService: PermissionService,
    private _userService: UserService,
  ) {
    combineLatest([
      this._featureFlagService.isPendoFeatureFlagOn$,
      this._identify$,
    ])
      .pipe(
        filter(([isPendoFeatureFlagOn]) => isPendoFeatureFlagOn),
        switchMap(() => this._userService.user$),
        withLatestFrom(this._permissionService.getPermissionList()),
      )
      .subscribe(([user, permissions]) => {
        const idPrefix = getIdPrefix();
        const visitor = {
          account_admin: permissions.includes(Permission.UserAccountAdmin),
          app_name: 'HE Mobile Manager',
          department_filtered: user.hasDepartmentFilters,
          email_address: user.emailAddress,
          first_name: user.name.first,
          hotel_admin: permissions.includes(Permission.UserHotelAdmin),
          hotel_suspension_list: user.hotelSuspensionList,
          hotel_suspension_status: user.hotelSuspensionStatus,
          id: idPrefix + user.userName,
          job_title: user.jobTitle,
          last_name: user.name.last,
          permissions,
          user_type: user.userType,
          wage_access: user.canSeeWages,
        };
        const account = {
          id: idPrefix + user.accounts[0].accountName,
        };
        if (this._isInitialized) {
          pendo.identify({ visitor, account });
        } else {
          pendo.initialize({ visitor, account });
          this._isInitialized = true;
        }
      });
  }

  identifyVisitor(): void {
    this._identify$.next();
  }

  clearSession(): void {
    if (this._isInitialized) {
      pendo.clearSession();
    }
  }
}

function getIdPrefix(): string {
  if (environment.production) {
    return '';
  }
  return `he-mobile-${environment.envName} `;
}
